import { Pipe, PipeTransform } from '@angular/core';
import { UnderageBirthdateErrorPipe } from './underage-birthdate-error.pipe';

@Pipe({
  name: 'underageBirthdate',
  standalone: true,
})
export class UnderageBirthdatePipe implements PipeTransform {
  public transform(day: string, month: string, year: string): boolean {
    if (!day || !month || !year) {
      return null;
    }

    return !new UnderageBirthdateErrorPipe().transform(day, month, year);
  }
}
